import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import {
  ProductClickEventRecord,
  ProductClickEventsService,
} from '../../../services/product-click-events/product-click-events.service';

@Component({
  selector: 'app-product-click-events',
  templateUrl: './product-click-events.component.html',
  styleUrls: ['./product-click-events.component.scss'],
})
export class ProductClickEventsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  readonly columnsToDisplay = [
    'occurredAt',
    'userName',
    'email',
    'brand',
    'rewardTileName',
    'eventType',
    'buttonLabel',
    'actionType',
    'surface',
    'sourceType',
    'sourceId',
    'route',
    'metadata',
  ];
  readonly searchControl = new FormControl('');
  readonly items = new MatTableDataSource<ProductClickEventRecord>([]);
  total = 0;
  loading = false;
  errorMessage = '';
  private readonly destroyed = new Subject<void>();

  constructor(private productClickEventsService: ProductClickEventsService) {}

  ngOnInit(): void {
    this.searchControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.destroyed))
      .subscribe(() => {
        if (this.paginator) {
          this.paginator.firstPage();
        }
        this.load();
      });
  }

  ngAfterViewInit(): void {
    this.sort.sortChange.pipe(takeUntil(this.destroyed)).subscribe(() => {
      this.paginator.firstPage();
      this.load();
    });
    this.paginator.page.pipe(takeUntil(this.destroyed)).subscribe(() => this.load());
    this.load();
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  load(): void {
    this.loading = true;
    this.errorMessage = '';
    this.productClickEventsService.list({
      search: String(this.searchControl.value || '').trim() || undefined,
      page: (this.paginator?.pageIndex || 0) + 1,
      limit: this.paginator?.pageSize || 100,
      sort: this.sort?.active || 'occurredAt',
      direction: this.sort?.direction === 'asc' ? 'asc' : 'desc',
    }).then((response) => {
      this.items.data = response.items || [];
      this.total = response.total || 0;
    }).catch((error) => {
      console.error('Unable to load product click events', error);
      this.items.data = [];
      this.total = 0;
      this.errorMessage = 'Unable to load product click events.';
    }).finally(() => {
      this.loading = false;
    });
  }
}
